import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import {ApiService, ChatbotDef, RagSessionDef, RagTemplateDef} from "../../../services/api.service";
import {ActivatedRoute, Router} from "@angular/router";
import {JsonPipe, Location, NgClass, NgForOf, NgIf} from "@angular/common";
import {ActionsContainerComponent} from "../../../core/actions-container/actions-container.component";
import {BackButtonComponent} from "../../../core/back-button/back-button.component";
import {ErrorPanelComponent} from "../../../core/error-panel/error-panel.component";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatOptionModule} from "@angular/material/core";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatSelectModule} from "@angular/material/select";
import {QuickPreviewPanelComponent} from "../../../core/quick-preview-panel/quick-preview-panel.component";
import {Subscription} from "rxjs";


@Component({
  selector: 'session-manage',
  standalone: true,
  imports: [
    ActionsContainerComponent,
    BackButtonComponent,
    ErrorPanelComponent,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatOptionModule,
    MatProgressBarModule,
    MatSelectModule,
    NgClass,
    NgForOf,
    NgIf,
    QuickPreviewPanelComponent,
    ReactiveFormsModule,
    JsonPipe
  ],
  templateUrl: './session-manage.component.html'
})
export class SessionManageComponent implements OnInit, OnDestroy {

  form?: FormGroup
  chatbots: ChatbotDef[] = []
  templates: RagTemplateDef[] = []
  sessionId?: string
  existing?: RagSessionDef
  loading = false
  error?: any
  queryParamsSub?: Subscription
  cloningFromSource = false

  get isNew(): boolean {
    return !this.sessionId
  }

  get formAsSessionDef(): RagSessionDef {
    const result =  (this.form!.value as RagSessionDef)!
    if (!result.id && this.sessionId) {
      result.id = this.sessionId
    }
    return result
  }

  constructor(
    readonly api: ApiService,
    readonly route: ActivatedRoute,
    readonly router: Router,
    readonly fb: FormBuilder,
    readonly location: Location
  ) {

  }

  ngOnInit(): void {
    this.api.getChatbots().subscribe({
      next:(cb) => {
        this.chatbots = cb
        this.api.getTemplates().subscribe({
          next: (ts) => {
            this.templates = ts
            this.sessionId = this.route.snapshot.params['sessionId']
            this.invalidateForm()
            this.queryParamsSub = this.route.queryParams.subscribe({
              next:((qp) => {
                if (!this.sessionId && qp['source']) {
                  this.loading = true
                  this.cloningFromSource = true
                  this.api.getSession(qp['source']).subscribe({
                    next: (session) => {
                      session.name = `${session.name} copy (${Date.now()})`
                      this.form?.patchValue(session, {
                        emitEvent: true
                      })
                      this.loading = false
                    },
                    error: (e) => {
                      this.error = e
                      this.loading = false
                      this.cloningFromSource = false
                    }
                  })
                }
              })
            })
          }
        })
      }
    })
  }

  invalidateForm(): void {
    const chatbotId = this.chatbots.length ? this.chatbots[0].id : null
    const templateId = this.templates.length ? this.templates[0].id : null
    this.form = this.fb.group({
      isPendingNew: [this.sessionId === undefined],
      id: new FormControl({
        value: this.sessionId || '',
        disabled: false
      }),
      name: new FormControl({
          value: '', disabled: false
        }, [Validators.required]
      ),
      description: [''],
      chatbot: [chatbotId, Validators.required],
      templateId: [templateId, Validators.required],
    })
  }

  filterTemplatesForAssistant(assistantId?: string | null) {
    assistantId = assistantId || this.form!.value['chatbot']
    return assistantId ? this.templates.filter((t) => t.assistantId == assistantId) : []
  }

  save(): void {
    if (this.form?.valid) {
      const item = this.formAsSessionDef
      this.error = undefined
      this.loading = true
      this.api.createSession(item).subscribe({
        next: (p) => {
          this.loading = false
          this.router.navigate(['/sessions/preview', p.data, 'chat'])
            .catch((e) => console.error('Router error', e))
            .finally(() => {})
        },
        error: (e) => {
          this.loading = false
          this.error = e
        },
      })
    }
  }

  ngOnDestroy(): void {
    this.queryParamsSub?.unsubscribe()
    this.queryParamsSub = undefined
  }
}
